import type { PdfAnnotation } from '../types';
import { normalizeCommentReactions } from './commentReactions';

export type HiringResumePdfFeedItem = {
  annotationId: string;
  replyIndex: number | null;
  userId: string;
  userName: string;
  content: string;
  createdAt: Date;
  pageNumber?: number;
  reactions: Record<string, string[]>;
};

export function mapHiringResumePdfThreads(annotations: PdfAnnotation[]): Array<{
  root: HiringResumePdfFeedItem;
  replies: HiringResumePdfFeedItem[];
}> {
  return annotations
    .filter(ann => !!ann.id)
    .map(ann => ({
      root: {
        annotationId: ann.id as string,
        replyIndex: null,
        userId: String(ann.userId ?? ''),
        userName: ann.userName || 'Unknown',
        content: ann.content || '',
        createdAt: ann.createdAt instanceof Date ? ann.createdAt : new Date(ann.createdAt),
        pageNumber: ann.pageNumber,
        reactions: normalizeCommentReactions(ann.reactions),
      },
      replies: (ann.replies || []).map((reply, replyIndex) => ({
        annotationId: ann.id as string,
        replyIndex,
        userId: String(reply.userId ?? ''),
        userName: reply.userName || 'Unknown',
        content: reply.content || '',
        createdAt: reply.createdAt instanceof Date ? reply.createdAt : new Date(reply.createdAt),
        pageNumber: ann.pageNumber,
        reactions: normalizeCommentReactions(reply.reactions),
      })),
    }));
}
